import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Settings({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3 -3 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M17.4352122 22.455378c-3.1848367 0-5.775-2.53836-5.775-5.6595 0-3.12048 2.5901633-5.6595 5.775-5.6595 3.1848368 0 5.775 2.53902 5.775 5.6595 0 3.12114-2.5901632 5.6595-5.775 5.6595zm12.2598368-4.07484c.066-.51744.1151632-1.03488.1151632-1.58466 0-.54978-.0491632-1.06722-.1151632-1.58466l3.4811632-2.66772c.3131633-.24288.396-.67914.198-1.03488l-3.3-5.59482c-.198-.35574-.6431632-.4851-1.0068367-.35574l-4.1081633 1.617c-.858-.6468-1.782-1.18074-2.7881632-1.58466l-.627-4.28538c-.0498368-.38808-.396-.67914-.8088368-.67914h-6.6c-.4121632 0-.759.29106-.8088367.67914l-.6263265 4.28538c-1.0068368.40392-1.93083676.9537-2.78883676 1.58466l-4.10816326-1.617c-.37983674-.14586-.80883674 0-1.00683674.35574l-3.3 5.59482c-.21416326.35574-.11516326.792.198 1.03488l3.48116327 2.66772c-.06532653.51744-.11516327 1.05138-.11516327 1.58466 0 .53394.04983674 1.06722.11516327 1.58466l-3.48116327 2.66838c-.31316326.24222-.396.67914-.198 1.03488l3.3 5.59482c.198.35574.64316327.4851 1.00683674.35574l4.10816326-1.617c.858.6468 1.78199996 1.18008 2.78883676 1.58466l.6263265 4.28472c.0498367.38808.3966735.67914.8088367.67914h6.6c.4128368 0 .759-.29106.8088368-.67914l.627-4.28472c1.0061632-.40458 1.9301632-.95436 2.7881632-1.58466l4.1081633 1.617c.3798367.1452.8088367 0 1.0068367-.35574l3.3-5.59482c.198-.35574.1151633-.79266-.198-1.03488l-3.4811632-2.66838z" />
      </g>
    </svg>
  )
}

Settings.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
